import { useQuery } from '@tanstack/react-query';
import { adsService } from '../services/ads.service';

export function useAdTypeConfigs() {
  return useQuery({
    queryKey: ['ads', 'type-configs'],
    queryFn: () => adsService.getAdTypeConfigs(),
    staleTime: 1000 * 60 * 10, // 10 minutes - configs don't change often
  });
}
